export var SpaceUserTable;
(function (SpaceUserTable) {
    let AuthorityType;
    (function (AuthorityType) {
        AuthorityType.map = {};
        AuthorityType.None = 0;
        // export const ReadOnly = 5;
        // map[ReadOnly] = '読取のみ';
        AuthorityType.Editable = 10;
        AuthorityType.map[AuthorityType.Editable] = '編集可能';
        AuthorityType.Manage = 30;
        AuthorityType.map[AuthorityType.Manage] = '管理者';
        AuthorityType.Owner = 50;
        AuthorityType.map[AuthorityType.Owner] = 'オーナー';
        function hasManage(userAuthorityType) {
            switch (userAuthorityType) {
                case SpaceUserTable.AuthorityType.Owner:
                case SpaceUserTable.AuthorityType.Manage:
                    return true;
                default:
                    return false;
            }
        }
        AuthorityType.hasManage = hasManage;
        function createSelectableMap(userAuthorityType) {
            const selectableMap = {};
            const map = SpaceUserTable.AuthorityType.map;
            for (let id in map) {
                const numId = Number(id);
                const text = map[id];
                switch (numId) {
                    case SpaceUserTable.AuthorityType.Owner:
                        // なにもしない
                        break;
                    case SpaceUserTable.AuthorityType.Manage:
                        if (userAuthorityType === SpaceUserTable.AuthorityType.Owner) {
                            selectableMap[id] = text;
                        }
                        break;
                    default:
                        selectableMap[id] = text;
                        break;
                }
            }
            return selectableMap;
        }
        AuthorityType.createSelectableMap = createSelectableMap;
    })(AuthorityType = SpaceUserTable.AuthorityType || (SpaceUserTable.AuthorityType = {}));
})(SpaceUserTable || (SpaceUserTable = {}));
